import { render, staticRenderFns } from "./list-required.vue?vue&type=template&id=539771c6&lang=html"
import script from "./list-required.vue?vue&type=script&lang=js"
export * from "./list-required.vue?vue&type=script&lang=js"
import style0 from "./list-required.vue?vue&type=style&index=0&id=539771c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports